// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_jw-1";
export var quotedThread = "_jw-0";